import { Colors, Lightning } from '@lightningjs/sdk';
import { translate } from 'support/translate';
import { debounce, getImageTextureObj } from 'support/generalUtils';
import { constants } from 'aliases';
import TextLabel from '../TextLabel';

export interface InputFieldErrorTemplateSpec
  extends Lightning.Component.TemplateSpec {
  Icon: typeof Lightning.Texture;
  Text: typeof TextLabel;
}

const DEFAULT_WIDTH = 684;
const DEFAULT_PADDING_X = 8;

const INPUT_ERROR_OFFSET_Y = 5;
const INPUT_ERROR_RADIUS = [0, 0, 8, 8];
const INPUT_ERROR_STROKE = 2;
const INPUT_ERROR_FONT_SIZE = 18;
const INPUT_ERROR_TEXT_MARGIN_TOP = 8 + INPUT_ERROR_OFFSET_Y;
const INPUT_ERROR_ICON_SIZE = 18;
const INPUT_ERROR_ICON_MARGIN_RIGHT = 8;
const INPUT_ERROR_ICON_MARGIN_TOP = 10 + INPUT_ERROR_OFFSET_Y;
const TEXT_WIDTH = DEFAULT_WIDTH - 35;

export default class InputFieldError
  extends Lightning.Component<InputFieldErrorTemplateSpec>
  implements
    Lightning.Component.ImplementTemplateSpec<InputFieldErrorTemplateSpec>
{
  private _Icon = this.getByRef('Icon')!;
  private _Text = this.getByRef('Text')!;

  private handleManualAnnounce(key: string) {
    this.fireAncestors('$announce', key, { append: true });
  }

  private manualAnnounce = debounce(this.handleManualAnnounce.bind(this), 250);

  set errorMessage(message: string) {
    this._Text.patch({
      text: {
        text: message,
      },
    });
  }

  showError(show: boolean) {
    this.patch({
      visible: show,
    });
  }

  announce(inputType: string, errorMessage: string) {
    this.manualAnnounce(
      translate('ttsPrompts.login.invalidInput', inputType, errorMessage),
    );
  }

  static override _template(): Lightning.Component.Template<InputFieldErrorTemplateSpec> {
    const statusIcon = getImageTextureObj(
      'static/images/status-icon.svg',
      INPUT_ERROR_ICON_SIZE,
      INPUT_ERROR_ICON_SIZE,
    );
    return {
      visible: false,
      rect: true,
      zIndex: constants.ui.zIndex.foregroundLayer + 1,
      color: Colors('black').get(),
      w: DEFAULT_WIDTH,
      y: -INPUT_ERROR_OFFSET_Y, // y-offset to hide top stroke
      flex: {
        direction: 'row',
        paddingBottom: INPUT_ERROR_OFFSET_Y,
      },
      Icon: {
        ...statusIcon,
        flexItem: {
          marginLeft: DEFAULT_PADDING_X,
          marginRight: INPUT_ERROR_ICON_MARGIN_RIGHT,
          marginTop: INPUT_ERROR_ICON_MARGIN_TOP,
        },
        shader: null,
      },
      Text: {
        type: TextLabel,
        flexItem: { marginTop: INPUT_ERROR_TEXT_MARGIN_TOP },
        w: TEXT_WIDTH,
        shader: null,
        text: {
          fontSize: INPUT_ERROR_FONT_SIZE,
          textColor: Colors('white').get(),
          verticalAlign: 'middle',
          wordWrap: true,
        },
      },
      shader: {
        type: Lightning.shaders.RoundedRectangle,
        radius: INPUT_ERROR_RADIUS,
        stroke: INPUT_ERROR_STROKE,
        strokeColor: Colors('focusRed').get(),
      },
    };
  }
}
